'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _semanticUiReact = require('semantic-ui-react');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var twoRowsModeArrowStyle = {
  color: 'gray',
  display: 'block',
  float: 'right',
  marginLeft: -22,
  marginTop: -3,
  marginRight: -10
};

var oneRowModeArrowStyle = (0, _extends3.default)({}, twoRowsModeArrowStyle, {
  marginTop: 3
});

var SortArrow = function SortArrow(_ref) {
  var field = _ref.field,
      order = _ref.order,
      targetField = _ref.targetField,
      twoRowsMode = _ref.twoRowsMode;

  var shouldRenderIcon = _lodash2.default.eq(field, targetField);
  if (shouldRenderIcon) {
    return _react2.default.createElement(_semanticUiReact.Icon, {
      name: 'angle ' + (order === 'asc' ? 'up' : 'down'),
      style: twoRowsMode ? twoRowsModeArrowStyle : oneRowModeArrowStyle,
      size: 'small'
    });
  }
  return null;
};

SortArrow.propTypes = {
  field: _propTypes2.default.string.isRequired,
  order: _propTypes2.default.oneOf(['asc', 'desc']).isRequired,
  targetField: _propTypes2.default.string.isRequired,
  twoRowsMode: _propTypes2.default.boolean
};

SortArrow.defaultProps = {
  twoRowsMode: false
};

exports.default = SortArrow;


//////////////////
// WEBPACK FOOTER
// ./node_modules/dyzio-shared-components/lib/reports/google-analytics-report/sort-arrow.js
// module id = 2183
// module chunks = 1